import {AfterViewInit, Component, HostListener, Inject, Input, OnInit, PLATFORM_ID,
  CUSTOM_ELEMENTS_SCHEMA} from '@angular/core';
import {DefaultModalService} from '@app/shared/modal/services/default-modal.service';
import {UntilDestroy, untilDestroyed} from '@ngneat/until-destroy';
import {first} from 'rxjs';
import {isPlatformBrowser, NgTemplateOutlet, AsyncPipe} from '@angular/common';
import {CLOSE_EVENT} from '@app/services/iframe/iframe-message.service';
import '@ui5/webcomponents-icons/dist/decline.js';
import {JoinClassesDirective} from '../../../directives/commons/join-classes.directive';
import {TranslatePipe} from '@spartacus/core';

@UntilDestroy()
@Component({
  selector: 'dcp-default-modal',
  styleUrls: ['./default-modal.component.scss'],
  templateUrl: './default-modal.component.html',
  imports: [JoinClassesDirective, NgTemplateOutlet, AsyncPipe, TranslatePipe],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class DefaultModalComponent implements OnInit, AfterViewInit {
  @Input() modalId: string;
  topModalId: string | null = null;

  @HostListener('document:keydown', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent) {
    if (event.code === 'Escape' && this.modalId === this.topModalId) {
      this.closeModal();
    }
  }

  private messageHandler: (event: any) => void = (event) => {
    if (event.data?.eventId === CLOSE_EVENT && !event.origin.includes('dcp-support-ui')) {
      this.closeModal();
      event.stopPropagation();
    }
  };

  constructor(
    @Inject(PLATFORM_ID) public platformId: object,
    protected modalService: DefaultModalService,
  ) {
    if (isPlatformBrowser(this.platformId)) {
      window.addEventListener('message', this.messageHandler, false);
    }
  }

  ngOnInit(): void {
    this.modalService
      .getTopModalId()
      .pipe(first(), untilDestroyed(this))
      .subscribe((id) => {
        this.topModalId = id;
      });
  }

  ngAfterViewInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      // ui5 Dialog._center() runs before offsetWidth/offsetHeight are available when the
      // Popover API is used (udex >= 2.51.0). Dispatching resize after the first paint
      // forces _center() to recalculate with real dimensions.
      requestAnimationFrame(() => window.dispatchEvent(new Event('resize')));
    }
  }

  closeModal(): void {
    if (this.modalId) {
      this.modalService.closeModal(this.modalId);
    }
  }
}
